import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "styled-components";
import { theme } from "./themes/theme";

const rootElement = document.getElementById("root");

const tree = (
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(tree, rootElement);
} else {
  ReactDOM.render(tree, rootElement);
}
